import Link from 'next/link'
import { useRouter } from 'next/router'

import clsx from 'clsx'

type Props = {
	page: number | string
	current: number
	type?: string
	nextPage?: (page: number) => void
	as?: 'button' | 'anchor'
}

const getNewPage = ({ type, current, page }: Omit<Props, 'path'>) => {
	if (type === 'next') return current + 1
	if (type === 'prev') return current - 1
	return page as number
}

export function PaginationLink({ current, page, type, as, nextPage }: Props) {
	const { query } = useRouter()
	if (as === 'button') {
		return (
			<button
				className={clsx(
					current === page && 'text-gray-700 cursor-default',
					'text-bc-blue font-normal text-[17px]'
				)}
				key={page}
				onClick={() => nextPage?.(getNewPage({ current, page, type }))}
			>
				{page}
			</button>
		)
	}

	return (
		<Link
			className={clsx(
				current === page && 'text-gray-700 cursor-default',
				'text-bc-blue font-normal text-[17px]'
			)}
			key={page}
			href={{ query: { ...query, page: getNewPage({ current, page, type }) } }}
			shallow
		>
			{page}
		</Link>
	)
}
